<script setup>
import TableHeaderRow from "@/components/global-themed/table/TableHeaderRow.vue";
import TableHeaderCell from "@/components/global-themed/table/TableHeaderCell.vue";
import DataTable from "@/components/global-themed/table/DataTable.vue";
import {useStore} from "vuex";
import {computed} from "vue";
import TableBody from "@/components/global-themed/table/TableBody.vue";
import KeywordRow from "@/components/competition/partials/keywords/KeywordRow.vue";
import ZeroContent from "@/components/global-themed/ZeroContent.vue";

const store = useStore();

const orderBy = computed(() => store.getters['competitionV2/keywordOrderBy']);
const orderDirection = computed(() => store.getters['competitionV2/keywordOrderDirection']);

const rankedKeywords = computed(() => store.getters["competitionV2/filteredRankedKeywords"]);

const changeOrderBy = (name) => {
  store.dispatch('competitionV2/setKeywordOrder', name)
}

</script>

<template>
  <div>
    <DataTable>
      <TableHeaderRow>
        <TableHeaderCell
          col-span="3"
          :order-by="orderBy"
          :order-direction="orderDirection"
          name="key"
          @order-changed="changeOrderBy"
        >
          <span>Keyword</span>
        </TableHeaderCell>

        <TableHeaderCell
          col-span="3"
          :order-by="orderBy"
          :order-direction="orderDirection"
          name="relative_url"
          @order-changed="changeOrderBy"
        >
          <span>Website</span>
        </TableHeaderCell>

        <TableHeaderCell
          col-span="2"
          :order-by="orderBy"
          :order-direction="orderDirection"
          name="position"
          class="tw-justify-center"
          @order-changed="changeOrderBy"
        >
          <span>Position</span>
        </TableHeaderCell>

        <TableHeaderCell
          col-span="2"
          :order-by="orderBy"
          :order-direction="orderDirection"
          name="difficulty"
          class="tw-justify-center"
          @order-changed="changeOrderBy"
        >
          <span>Difficulty</span>
        </TableHeaderCell>

        <TableHeaderCell
          col-span="2"
          :order-by="orderBy"
          :order-direction="orderDirection"
          name="search_volume"
          @order-changed="changeOrderBy"
        >
          <span>Search Volume</span>
        </TableHeaderCell>
      </TableHeaderRow>

      <TableBody
        v-if="rankedKeywords.length > 0"
        class="tw-max-h-[70vh]"
      >
        <KeywordRow
          v-for="rankedKeyword in rankedKeywords"
          :key="rankedKeyword.key"
          :ranked-keyword="rankedKeyword"
        />
      </TableBody>
      <ZeroContent v-if="!rankedKeywords.length">
        Looks like there are no ranked keywords to display.
      </ZeroContent>
    </DataTable>
  </div>
</template>
